/*
 * @Author: 姚阳子 yaoyangzi@linhuiba.com
 * @Date: 2023-05-12 10:52:29
 * @LastEditors: 姚阳子 yaoyangzi@linhuiba.com
 * @LastEditTime: 2023-05-12 16:03:26
 * @FilePath: /locationpms-pc/src/utils/auth.js
 * @Description:
 *
 *
 */
import axios from 'axios';
import cache from './cache';
import store from '@/store';
import Cookies from 'js-cookie';
import { getCookiesDomain } from '@/utils/index.js';
/** 移除授权信息 */
export function removeAuth() {
    return new Promise(function (resolve) {
        // if (props.clearCookies) {
        //   Cookies.remove('User', { path: '/', domain: '.72crm.com' })
        // }
        cache.rmAxiosCache();
        store.commit('SET_ALLAUTH', null);
        delete axios.defaults.headers['Admin-Token'];
        delete axios.defaults.headers['channel'];
        resolve(true);
    });
}
/** 注入授权信息 */
export function addAuth(data) {
    return new Promise(function (resolve) {
        axios.defaults.headers['Admin-Token'] = data.adminToken;
        axios.defaults.headers['channel'] = data.channel;
        // store.dispatch('SystemLogoAndName')
        resolve(true);
    });
}
/** 获取授权信息 */
export function getAuth(to) {
    return new Promise(function (resolve, reject) {
        var _a = (to.query || {}).channel, propChannel = _a === void 0 ? '' : _a;
        if (localStorage.getItem('AdminToken') && propChannel && propChannel !== localStorage.getItem('channel')) {
            reject();
            return;
        }
        if (axios.defaults.headers['Admin-Token'] && axios.defaults.headers['channel']) {
            resolve();
        }
        else {
            var cookieAdminToken = Cookies.get('AdminToken');
            var cookieChannel = Cookies.get('channel');
            var lockAdminToken = localStorage.getItem('AdminToken');
            var lockChannel = localStorage.getItem('channel');
            // 状态码 1007 下 会忽略下一次的cookies信息读取
            // 重点 数据以cookie为准，只要cookie有值，或者与localstorage不同，覆盖localstorage
            if (window.sessionStorage.wkIgnoreCookies !== true && !!cookieAdminToken && !!cookieChannel && (lockAdminToken !== cookieAdminToken || lockChannel !== cookieChannel)) {
                localStorage.setItem('AdminToken', cookieAdminToken);
                lockAdminToken = cookieAdminToken;
                localStorage.setItem('channel', cookieChannel);
                lockChannel = cookieChannel;
            }
            // 本地有lock
            if (!!lockAdminToken && !cookieAdminToken) {
                var domain = getCookiesDomain();
                Cookies.set('AdminToken', lockAdminToken, { domain: domain, expires: 365 });
            }
            // 本地有channel
            if (!!lockChannel && !cookieChannel) {
                var domain = getCookiesDomain();
                Cookies.set('channel', lockChannel, { domain: domain, expires: 365 });
            }
            if (lockAdminToken && lockChannel) {
                // @ts-ignore
                cache.updateAxiosCache();
                store.dispatch('GetUserInfo').then(function () {
                    // 不忽略Cookies
                    window.sessionStorage.wkIgnoreCookies = false;
                    resolve();
                }).catch(function () {
                    reject();
                });
            }
            else {
                reject();
            }
        }
    });
}
